<script setup>
import { ref } from 'vue';
import { useWaitlistStore } from '../store/useWaitlist';
const props = defineProps({
  contato: { type: Object, default: () => ({}) },
  editItem: { type: Object, default: null },
});
const emit = defineEmits(['close']);
const store = useWaitlistStore();
const procedimento = ref(props.editItem ? (props.editItem.procedimento || '') : '');
const profissional_pref = ref(props.editItem ? (props.editItem.profissional_pref || 'qualquer') : 'qualquer');
const janela = ref(props.editItem ? (props.editItem.janela || 'qualquer') : 'qualquer');
const observacao = ref(props.editItem ? (props.editItem.observacao || '') : '');
const saving = ref(false);
async function salvar() {
  saving.value = true;
  try {
    if (props.editItem) {
      await store.update(props.editItem.id, {
        procedimento: procedimento.value, profissional_pref: profissional_pref.value || 'qualquer',
        janela: janela.value, observacao: observacao.value,
      });
    } else {
      await store.add({
        contact_chatwoot_id: props.contato.id, conversation_chatwoot_id: props.contato.conversationId,
        nome: props.contato.nome, telefone: props.contato.telefone,
        procedimento: procedimento.value, profissional_pref: profissional_pref.value || 'qualquer',
        janela: janela.value, observacao: observacao.value, criado_por: props.contato.atendente,
      });
    }
    emit('close');
  } finally { saving.value = false; }
}
</script>
<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" @click.self="emit('close')">
    <div class="bg-n-background rounded-xl p-5 w-96 shadow-lg">
      <h2 class="font-semibold mb-3">{{ editItem ? 'Editar reserva' : 'Adicionar à lista de espera' }}</h2>
      <p class="text-sm text-n-slate-11 mb-3">{{ editItem ? editItem.nome : (contato.nome + ' · ' + contato.telefone) }}</p>
      <label class="block text-xs mb-1">Procedimento / especialidade</label>
      <input v-model="procedimento" class="w-full mb-2 px-2 py-1 rounded border border-n-weak bg-transparent" />
      <label class="block text-xs mb-1">Profissional preferido</label>
      <input v-model="profissional_pref" placeholder="qualquer" class="w-full mb-2 px-2 py-1 rounded border border-n-weak bg-transparent" />
      <label class="block text-xs mb-1">Janela</label>
      <select v-model="janela" style="color-scheme: dark" class="w-full mb-2 px-2 py-1 rounded border border-n-weak bg-transparent">
        <option value="qualquer" style="background-color:#1f2d3d;color:#fff">Qualquer horário</option><option value="manha" style="background-color:#1f2d3d;color:#fff">Manhã</option><option value="tarde" style="background-color:#1f2d3d;color:#fff">Tarde</option>
      </select>
      <label class="block text-xs mb-1">Observação</label>
      <textarea v-model="observacao" class="w-full mb-3 px-2 py-1 rounded border border-n-weak bg-transparent" rows="2" />
      <div class="flex justify-end gap-2">
        <button class="px-3 py-1" @click="emit('close')">Cancelar</button>
        <button class="px-3 py-1 rounded bg-n-brand text-white" :disabled="saving" @click="salvar">{{ saving ? 'Salvando…' : (editItem ? 'Salvar' : 'Adicionar') }}</button>
      </div>
    </div>
  </div>
</template>
